import React from "react";

export const AsyncStudentDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "StudentDashboard" */
      "pages/StudentDashboard"
    )
);
export const AsyncTeacherDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TeacherDashboard" */
      "pages/TeacherDashboard"
    )
);
export const AsyncMyProgress = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MyProgress" */
      "pages/MyProgress"
    )
);
export const AsyncLessonFeedback = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LessonFeedbackPage" */
      "pages/LessonFeedback/LessonFeedbackPage"
    )
);
export const AsyncPostSessionFeedback = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PostSessionFeedbackPage" */
      "pages/PostSessionFeedback/PostSessionFeedbackPage"
    )
);
export const AsyncSearch = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SearchPage" */
      "pages/Search/SearchPage"
    )
);
export const AsyncStudentSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "StudentSettingsPage" */
      "pages/Settings/StudentSettingsPage"
    )
);
export const AsyncTeacherSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TeacherSettingsPage" */
      "pages/Settings/TeacherSettingsPage"
    )
);
export const AsyncStudents = React.lazy(
  () =>
    import(
      /* webpackChunkName: "StudentsPage" */
      "pages/Students/StudentsPage"
    )
);
export const AsyncStudentDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "StudentDetailsPage" */
      "pages/StudentDetails/StudentDetailsPage"
    )
);
export const AsyncTeacherDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TeacherDetailsPage" */
      "pages/TeacherDetails/TeacherDetailsPage"
    )
);
export const AsyncConversation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ConversationPage" */
      "pages/Conversation/ConversationPage"
    )
);
export const AsyncTeamDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TeamDashboardPage" */
      "pages/team/TeamDashboard/TeamDashboardPage"
    )
);
export const AsyncCompanyReportsPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ReportsPage" */
      "pages/team/ReportsPage/index"
    )
);
export const AsyncTeamsPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TeamsPage" */
      "pages/team/CompanyDashboard/TeamsPage"
    )
);
export const AsyncTeamMember = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TeamMemberPage" */
      "pages/team/TeamMember/TeamMemberPage"
    )
);
export const AsyncLibrary = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LibraryObjectRedirect" */
      "pages/Library/LibraryObjectRedirect"
    )
);
export const AsyncLessonPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LessonPage" */
      "pages/Lesson/LessonPage"
    )
);
export const AsyncLibraryRoot = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LibraryRootPage" */
      "pages/Library/LibraryRootPage"
    )
);
export const AsyncExercises = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExercisesPage" */
      "pages/Exercises/ExercisesPage"
    )
);
export const AsyncExerciseDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExerciseDetailsPage" */
      "pages/ExerciseDetails/ExerciseDetailsPage"
    )
);
export const AsyncExerciseAssignmentDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExerciseAssignmentDetailsPage" */
      "pages/ExerciseAssignmentDetails/ExerciseAssignmentDetailsPage"
    )
);
export const AsyncTagSearch = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TagSearchPage" */
      "pages/TagSearch/TagSearchPage"
    )
);
export const AsyncExerciseCreator = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExerciseCreatorPage" */
      "pages/ExerciseCreator/ExerciseCreatorPage"
    )
);
export const AsyncExerciseEditor = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExerciseEditorPage" */
      "pages/ExerciseEditor/ExerciseEditorPage"
    )
);
export const AsyncMyTeacherExerciseList = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MyTeacherExerciseListPage" */
      "pages/Exercises/MyTeacherExerciseListPage"
    )
);
export const AsyncCoursePage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CoursePage" */
      "pages/Course/CoursePage"
    )
);
export const AsyncAdaptiveTestPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdaptiveTest" */
      "pages/AdaptiveTest"
    )
);
export const AsyncSpeakingclubPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SpeakingClubPage" */
      "pages/SpeakingClubPage"
    )
);

export const AsyncOauthLoading = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OAuthLoadingPage" */
      "pages/OAuthLoading/index"
    )
);

export const AsyncPracticePage = React.lazy(
  /* webpackChunkName: "AsyncPracticePage" */
  () => import("pages/Practice")
);

export const AsyncSkillsPage = React.lazy(
  /* webpackChunkName: "AsyncCommunicationSkillsPage" */
  () => import("pages/CommunicationSkills")
);

export const AsyncTalkToTallyPage = React.lazy(
  /* webpackChunkName: "AsyncTalkToTallyPage" */
  () => import("pages/TalkToTally")
);

export const AsyncPaymentPage = React.lazy(
  /* webpackChunkName: "AsyncPaymentPage" */
  () => import("pages/Payment")
);

export const AsyncOfferPage = React.lazy(
  /* webpackChunkName: "OfferPage" */
  () => import("pages/Offer/OfferPage")
);

export const AsyncSetupPage = React.lazy(
  /* webpackChunkName: "SetupPage" */
  () => import("pages/Setup/SetupPage")
);

export const AsyncAdminDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminDashboardPage" */
      "pages/admin/AdminDashboard/AdminDashboardPage"
    )
);

export const AsyncAdminExerciseList = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminExerciseList" */
      "pages/admin/AdminDashboard/components/AdminExerciseList/AdminExerciseList"
    )
);

export const AsyncAdminTagList = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminTagList" */
      "pages/admin/AdminDashboard/components/AdminTagList/AdminTagList"
    )
);

export const AsyncAdminUser = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminUserPage" */
      "pages/admin/AdminUser/AdminUserPage"
    )
);

export const AsyncAdminCompany = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminCompanyPage" */
      "pages/admin/AdminCompany/AdminCompanyPage"
    )
);

export const AsyncAdminCompanyTeam = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminCompanyTeamPage" */
      "pages/admin/AdminCompanyTeam/AdminCompanyTeamPage"
    )
);

export const AsyncAdminSession = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSessionPage" */
      "pages/admin/AdminSession/AdminSessionPage"
    )
);

export const AsyncAdminMonitoring = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminMonitoringShiftPage" */
      "pages/admin/AdminMonitoring/AdminMonitoringShiftPage"
    )
);

export const AsyncAdminQuestion = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminQuestionPage" */
      "pages/admin/AdminQuestion/AdminQuestionPage"
    )
);

export const AsyncAdminSchool = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSchoolPage" */
      "pages/admin/AdminSchool/AdminSchoolPage"
    )
);

export const AsyncAdminSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSettingsPage" */
      "pages/admin/AdminSettings/AdminSettingsPage"
    )
);

export const AsyncAdminBuildExercise = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminBuildExercisePage" */
      "pages/admin/AdminBuildExercise/AdminBuildExercisePage"
    )
);

export const AsyncAdminExercise = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminExercisePage" */
      "pages/admin/AdminExercise/AdminExercisePage"
    )
);

export const AsyncAdminTag = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminTagPage" */
      "pages/admin/AdminTag/AdminTagPage"
    )
);

export const AsyncAdminWorkshop = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminTagPage" */
      "pages/admin/AdminWorkshop/AdminWorkshop"
    )
);

export const AsyncAdminPricingModel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminPricingModelPage" */
      "pages/admin/AdminPricingModel/AdminPricingModelPage"
    )
);

export const AsyncContentFolder = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContentFolderPage" */
      "pages/admin/Content/ContentFolderPage"
    )
);

export const AsyncEditContentFile = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EditContentFilePage" */
      "pages/admin/Content/EditContentFilePage"
    )
);

export const AsyncCustomerServiceMonitoring = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminMonitoringShiftPage" */
      "pages/admin/AdminMonitoring/AdminMonitoringShiftPage"
    )
);

export const AsyncCustomerServiceSession = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSessionPage" */
      "pages/admin/AdminSession/AdminSessionPage"
    )
);

export const AsyncAdminAdaptiveTestingQuestionDetail = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminAdaptiveTestingQuestionDetail" */
      "pages/admin/AdminAdaptiveTestingQuestionDetail/AdminAdaptiveTestingQuestionDetail"
    )
);
